<template>
    <div class="task-item v3">
        <div class="task-icon" :class="`task-icon-${taskDetail.type}`"></div>
        <div class="task-msg">
            <div class="task-name">{{ taskDetail.name }}</div>
            <div class="task-desc">{{ taskDetail.text }}</div>
        </div>
        <div
            v-debounce="handleClickTask"
            :class="taskClass"
        >
        </div>
    </div>
</template>

<script>
import {mapMutations, mapState, mapActions} from 'vuex';
import {openShare} from '@baidu/map-fe-utils';
import {initMainShare} from '@/pages/pano-game/constant/ShareConfig';
import {jumpByOpenapi, closeNativePage} from '@/pages/pano-game/constant/JumpFunc';
import StatisticConst from '@/pages/pano-game/constant/StatisticConst';
import Const from '@/pages/pano-game/constant/Constant';

export default {
    data() {
        return {
            taskDetail: this.taskData
        };
    },
    props: {
        taskData: {
            type: Object,
            default: null
        }
    },
    computed: {
        ...mapState(['isLogin', 'myCoin', 'staticImgData', 'mainUrl']),
        taskClass() {
            const taskClass = ['task-btn'];
            if (this.taskDetail.status === Const.taskStatus.wait) {
                taskClass.push('go-task-btn');
            }
            else if (this.taskDetail.status === Const.taskStatus.fixed) {
                taskClass.push('get-coins-btn');
            }
            else if (this.taskDetail.status === Const.taskStatus.received) {
                taskClass.push('finish-task-btn');
            }
            return taskClass;
        }
    },
    watch: {
        taskData(newVal) {
            this.taskDetail = newVal;
        }
    },
    mounted() {
        setTimeout(() => {
            initMainShare({
                url: this.mainUrl,
                wxPic: this.staticImgData.shareWxImgUrl,
                weiboPic: this.staticImgData.shareWbImgUrl,
                wxText: this.staticImgData.shareWbWxText,
                wxFriendText: this.staticImgData.shareWbWxText,
                weiboText: this.staticImgData.shareWbWxText
            });
        }, 1000);
    },
    methods: {
        ...mapMutations(['setMyCoin']),
        ...mapActions([
            'getMainData'
        ]),
        ...mapActions('welfare', [
            'getCoins',
            'finishTask'
        ]),
        // 点击任务
        handleClickTask() {
            if (this.taskDetail.status === Const.taskStatus.wait) {
                this.completeTask(this.taskDetail.type);
            }
            else if (this.taskDetail.status === Const.taskStatus.fixed) {
                this.handleGetCoins(this.taskDetail.type);
            }
        },
        // 完成任务
        completeTask(type) {
            StatisticConst.taskComplete(type);
            switch (type) {
                case Const.taskType.ordinary:
                    this.goPanoPage();
                    break;
                case Const.taskType.note:
                    this.goNotePage();
                    break;
                case Const.taskType.share:
                    this.goShare();
                    break;
            }
        },
        goPanoPage() {
            const url  = location.origin + location.pathname + '#/pano?type=ordinary';
            jumpByOpenapi(url);
        },
        goNotePage() {
            closeNativePage();
            const url  = location.origin + location.pathname + '#/note';
            jumpByOpenapi(url);
        },
        goShare() {
            openShare();
            // 设置异步，完成分享任务
            setTimeout(() => {
                this.finishTask({type: Const.taskType.share}).then(resData => {
                    this.taskDetail.status = 1;
                }).catch(err => {
                    throw new Error(err);
                });
            }, 2000);
        },
        // 点击领取金币
        handleGetCoins(type) {
            StatisticConst.getCoins(type);
            this.getCoins({type}).then(res => {
                if (res && res.errno === 0 && res.data && res.data.result) {
                    this.setMyCoin(res.data.coin);
                    this.taskDetail.status = 2;
                }
            });
        }
    }
};
</script>
<style lang='scss'>
.task-item {
    width: 304px;
    height: 62px;
    margin-left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
    position: relative;
    background: url('../../../assets/v2/welfare/task-item.png');
    background-size: cover;
    display: flex;
    align-items: center;

    .task-icon-tordinary {
        width: 32px;
        height: 42px;
        background: url('../../../assets/v2/welfare/daren-icon.png');
    }

    .task-icon-tmaster {
        width: 32px;
        height: 39px;
        background: url('../../../assets/v2/welfare/dashi-icon.png');
    }

    .task-icon-twrong {
        width: 32px;
        height: 37px;
        background: url('../../../assets/v2/welfare/note-icon.png');
    }

    .task-icon-tshare {
        width: 32px;
        height: 32px;
        background: url('../../../assets/v2/welfare/share-icon.png');
    }

    .task-icon {
        position: absolute;
        left: 12px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .task-msg {
        position: absolute;
        left: 50px;
        font-family: PingFang SC;
        color: #fff;
        text-shadow: 0 0 4px #62fbff;
        font-weight: 500;

        .task-name {
            font-size: 15px;
            height: 15px;
            display: flex;
            align-items: center;
            margin-bottom: 6px;
        }

        .task-desc {
            font-style: 12px;
            height: 11px;
            display: flex;
            align-items: center;
        }
    }


    .task-btn {
        width: 98px;
        height: 60px;
        position: absolute;
        right: 0;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

        &.go-task-btn {
            background-image: url('../../../assets/v2/welfare/todo-btn.png');
        }

        &.get-coins-btn {
            background-image: url('../../../assets/v2/welfare/coin-btn.png');
        }

        &.finish-task-btn {
            background-image: url('../../../assets/v2/welfare/received-btn.png');
        }
    }
    &.v3 {
        width: 357px;
        height: 92px;
        margin: 0 0 15px 0;
        transform: none;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('../../../assets/v3/welfare/taskBg.png');
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .task-icon {
            position: static;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;

            &.task-icon-tordinary,
            &.task-icon-tmaster {
                margin-left: 27px;
                width: 28px;
                height: 39px;
                background-size: cover;
                background-repeat: no-repeat;
                background-image: url('../../../assets/v3/welfare/locIcon2.png');
            }

            &.task-icon-twrong {
                margin-left: 25px;
                width: 33px;
                height: 40px;
                background-size: cover;
                background-repeat: no-repeat;
                background-image: url('../../../assets/v3/welfare/noteIcon.png');
            }

            &.task-icon-tshare {
                margin-left: 23px;
                width: 38px;
                height: 38px;
                background-size: cover;
                background-repeat: no-repeat;
                background-image: url('../../../assets/v3/welfare/shareIcon.png');
            }
        }
        .task-msg {
            margin-left: 10px;
            position: static;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            .task-name {
                display: block;
                font-size: 15px;
                font-family: PingFang-SC-Regular;
                color: #43E4FF;
                text-shadow: 0 0 4px #62fbff;
                font-weight: 500;
                margin-bottom: 10px;
            }

            .task-desc {
                display: block;
                transform: none;
                font-size: 12px;
                font-family: PingFang-SC-Regular;
                color: #FCFF22;
                text-shadow: 0 0 4px #62fbff;
                font-weight: 500;
            }
        }
        .task-btn {
            right: 10px;
            width: 117px;
            height: 70px;
            &.go-task-btn {
                background-image: url('../../../assets/v3/welfare/todoBtn.png');
            }
            &.get-coins-btn {
                background-image: url('../../../assets/v3/welfare/getCoinBtn.png');
            }
            &.finish-task-btn {
                background-image: url('../../../assets/v3/welfare/receivedBtn.png');
            }
        }
    }
}
</style>